import React, {useRef} from "react";
import {useReactToPrint} from "react-to-print";
import log from "./log";

//reactToPrintCfg is optional, and comes from here:
//https://github.com/MatthewHerbst/react-to-print?tab=readme-ov-file#api
//A warning here, I'm not sure it's entirely safe to do things in onBeforePrint
//even though it says you can return a promise
const withReactToPrint = (Component, reactToPrintCfg) => {
    function WrappedCmp(props) {

        //make sure this ref is created here, and passed directly into ref={} property of a native element.
        //eg. <div ref={this.props.reactToPrint.toPrintRef}>
        const contentRef = useRef(null);

        const defaultCfg = {
            preserveAfterPrint : false,
            // onBeforePrint : () => {
            //   log.log("beforePrint()");
            //   return Promise.resolve(true);
            // },
            // onAfterPrint : () => {
            //     log.log("afterPrint()");
            // },
            onPrintError : (errorLocation, error) => {
                log.error('onPrintError()', errorLocation, error);
            }
        };
        let actualCfg = {
            ...defaultCfg,
            ...(reactToPrintCfg || {}),
        }

        //It is important that everything is done loading by the time handlePrint
        //actually gets called, or you could have weird caching problems.
        //when handlePrint's promise returns, the data has been sent to the browser,
        //so it can safely be used for cleanup sorts of things.
        const handlePrint = useReactToPrint({
            ...actualCfg,
            contentRef
        });
        return (
          <Component
            {...props}
            reactToPrint={{
                toPrintRef: contentRef,
                handlePrint
            }}/>
        );
    }
    return WrappedCmp;
}

export default withReactToPrint;